import styled from 'styled-components';

export const Files = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  width: 100%;
  margin: ${p => p.theme.spacing(13)} 0px ${p => p.theme.spacing(17)} 0px;
  flex-wrap: wrap;
`;

export const File = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  width: 100%;
  margin-top: 20px;
  border-style: solid;
  border-width: 2px;
  border-color: red;
  background: url(${p => p.svg});
`;



// WEBPACK FOOTER //
// ./src/components/FileHandler/styles.js